import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  private userPermissionsList : any = [];  
  

  setItem(key: string, value: any): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error('LocalStorage Error:', error);
    }
  }

  getItem<T>(key: string): T | null {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) as T : null;
    } catch (error) {
      console.error('LocalStorage Error:', error);
      return null;
    }
  }

  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('LocalStorage Error:', error);
    }
  }

  clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('LocalStorage Error:', error);
    }
  }  


  isLoggedIn(): boolean {    
    return this.getItem("userInfo") ? true : false;
  }
 
  setUserPermissions(userPermissions : any = []){
    this.userPermissionsList = userPermissions;
  }

  listUserPermissions(){
    return this.userPermissionsList ?? [];
  }

  checkPermission(permissionName :  string){
    return this.listUserPermissions().includes(permissionName) ?? false;
  }


}
